import { LocalizationProvider, TimePicker } from '@mui/x-date-pickers';
import { useScheduleContext } from '../../Contexts/ScheduleContext';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import type { Dayjs } from 'dayjs';
import { IconButton, Stack } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export default function SchedulePostInput({ id, onDelete }: { id: number; onDelete: () => void }) {
	const { setPostTimes, postTimes } = useScheduleContext();

	const handleTimeInput = (date: Dayjs | null) => {
		if (date) {
			setPostTimes(prev => {
				const newPostTimes = [...prev];
				newPostTimes[id] = date;
				return newPostTimes;
			});
		}
	};

	return (
		<LocalizationProvider dateAdapter={AdapterDayjs}>
			<Stack direction="row" alignItems="center" spacing={1}>
				<TimePicker
					sx={{ width: '200px' }}
					value={postTimes[id] ?? null}
					onChange={handleTimeInput}
				/>
				{postTimes[id] && (
					<IconButton onClick={onDelete}>
						<CloseIcon fontSize="small" />
					</IconButton>
				)}
			</Stack>
		</LocalizationProvider>
	);
}
